
<script>
export default {
  computed: {
    isDrawerOpen: {
      get: function () {
        return this.$store.getters["isDrawerOpen"];
      },
      set: function (newVal) {
        this.$store.commit("isDrawerOpen", newVal);
      },
    },
  },
};
</script>
